import React, { PropsWithChildren, useEffect } from 'react';
import styled from 'styled-components';

import { Dialog, ModalPortal } from '@hoffmann/pattern-library-2';

import { withStyledClasses } from '../../styled/withStyledClasses';
import { callIfFunction } from '../../utils/callIfFunction';

interface Props {
  width?: string;
  isOpen: boolean;
  title: React.ReactNode;
  onClickOutside?: () => void;
  onEscPressed?: () => void;
}

export const StyledModal: React.FC<PropsWithChildren<Props>> = ({
  title,
  width = '560px',
  isOpen,
  children,
  onClickOutside,
  onEscPressed,
}) => {
  useEffect(() => {
    const onKeyUp = (e: KeyboardEvent) => {
      if (e.key.toLowerCase() === 'escape') {
        callIfFunction(onEscPressed);
      }
    };
    document.addEventListener('keyup', onKeyUp);
    return () => {
      document.removeEventListener('keyup', onKeyUp);
    };
  }, [onEscPressed]);

  return (
    <StyledModalPortal isOpen={isOpen} overridenWidth={width} onClose={onClickOutside}>
      <Dialog title={title} size={200}>
        {children}
      </Dialog>
    </StyledModalPortal>
  );
};

const StyledModalPortal = styled(withStyledClasses(ModalPortal))<{ overridenWidth: string }>`
  ${({ overridenWidth }) => `
  .hpl2-Dialog.hpl2-Dialog--size-200 {
    max-width: ${overridenWidth};
    width: ${overridenWidth};
  }

  .hpl2-Dialog--size-200 .hpl2-Dialog__header,
  .hpl2-Dialog--size-200 .hpl2-Dialog__content,
  .hpl2-Dialog--size-200 .hpl2-Dialog__footer {
    width: 100%;
    max-width: none;
  }
`}
`;
